// TODO: this is a barrel file. Meanwhile, DirectMessages have an index file that is NOT a barrel file but contains logic etc. Decide on a consistent pattern for this?

import { NotificationPopover } from "./NotificationPopover";

export const Notifications = () => <NotificationPopover />;
